import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./Home";
import Login from "./Login";
import LoginUserName from "./LoginUserName";
import Brands from "./panel/Brands/[compId]";
import Favourite from "./panel/Favourite";
import Notifications from "./panel/Notifications";
import Setting from "./panel/Setting";
import SetLocation from "./SetLocation";
import Verify from "./Verify";
import Cart from "./panel/Cart";
import Canceled from "./panel/orders/Canceled";
import Confirmed from "./panel/orders/Confirmed";
import NewOrders from "./panel/orders/NewOrders";
import Ongoing from "./panel/orders/Ongoing";
import PayList from "./panel/orders/PayList";
import Returned from "./panel/orders/Returned";
import ShowFactor from "./panel/factor/[factorId]";
import EditOrder from "./panel/edit_order/[orderId]";
import Profile from "./panel/Profile";
import ComebackOrder from "./panel/comeback/[orderId]";
import ReturnOrder from "./panel/return/[orderId]";
import PayInfo from "./panel/pay/[payId]";
import EditProfile from "./panel/EditProfile";
import Category from "./panel/Category";
import Reports from "./panel/Reports";
import ContactUs from "./panel/ContactUs";
import ShopProducts from "./panel/shop/[shopId]";
import Product from "./panel/product/[productId]";
import Festival from "./panel/Festival";
import BrandProducts from "./panel/Brands/products/[brandId]";

function App() {
    return (
        <div className="App">
            <ToastContainer
                rtl={true}
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                pauseOnFocusLoss={false}
                draggable
                pauseOnHover={false}
            />
            <BrowserRouter>
                <Routes>
                    <Route>
                        <Route path="/" element={<Home />} />
                        <Route
                            path="/products/:shopId"
                            element={<ShopProducts />}
                        />
                        <Route
                            path="/brands/:compId/:brandId"
                            element={<BrandProducts />}
                        />
                        <Route path="/login" element={<Login />} />
                        <Route path="/verify" element={<Verify />} />
                        <Route path="/login_user" element={<LoginUserName />} />
                        <Route path="/set_location" element={<SetLocation />} />
                        <Route path="/panel/setting" element={<Setting />} />
                        <Route
                            path="/panel/notifications"
                            element={<Notifications />}
                        />
                        <Route path="/panel/festival" element={<Festival />} />
                        <Route
                            path="/panel/favorites"
                            element={<Favourite />}
                        />
                        <Route path="/brands/:compId" element={<Brands />} />
                        <Route path="/panel/cart" element={<Cart />} />
                        <Route
                            path="/panel/orders/new_orders"
                            element={<NewOrders />}
                        />
                        <Route
                            path="/panel/orders/ongoing"
                            element={<Ongoing />}
                        />
                        <Route
                            path="/panel/orders/confirmed"
                            element={<Confirmed />}
                        />
                        <Route
                            path="/panel/orders/returned"
                            element={<Returned />}
                        />
                        <Route
                            path="/panel/orders/canceled"
                            element={<Canceled />}
                        />
                        <Route
                            path="/panel/orders/pay_list"
                            element={<PayList />}
                        />
                        <Route
                            path="/panel/factor/:factorId"
                            element={<ShowFactor />}
                        />
                        <Route
                            path="/panel/edit_order/:orderId"
                            element={<EditOrder />}
                        />
                        <Route path="/panel/profile" element={<Profile />} />
                        <Route
                            path="/panel/return/:orderId"
                            element={<ReturnOrder />}
                        />
                        <Route
                            path="/panel/comeback/:orderId"
                            element={<ComebackOrder />}
                        />
                        <Route path="/panel/pay/:payId" element={<PayInfo />} />
                        <Route
                            path="/panel/product/:shopId/:productId"
                            element={<Product />}
                        />
                        <Route
                            path="/panel/edit_profile"
                            element={<EditProfile />}
                        />
                        <Route
                            path="/panel/categories"
                            element={<Category />}
                        />
                        <Route path="/panel/reports" element={<Reports />} />
                        <Route
                            path="/panel/contact_us"
                            element={<ContactUs />}
                        />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
